var e, s;
function r() {
  if (s) return e;
  s = 1;
  return e = class {
    constructor(e, s) {
      this.sender = e, this.customHeaders = s;
    }
    send(e) {
      for (let s in this.customHeaders) e.headers[s] = this.customHeaders[s];
      return new Promise((s, r) => {
        this.sender.send(e).then(s).catch(r);
      });
    }
  };
}
export { r as __require };